(function() { window.GUID_1a5ca0fa_912c_45d8_96a2_2fb64c5aa7ef = { getGuid: function() { return "1a5ca0fa-912c-45d8-96a2-2fb64c5aa7ef"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            class ProgressTouch extends VideoPlayerInternals.BaseInternal {
                constructor(player) {
                    super(player);
                    this.touchZone = new TouchZone();
                }
                OnBindEvents() {
                    this.event($('body'))
                        .offon("touchstart", (e, a) => { this.touchstart(e); })
                        .offon("touchend", (e, a) => { this.touchend(e); })
                        .offon("touchcancel", (e, a) => { this.touchcancel(e); })
                        .offon("touchmove", (e, a) => { this.touchmove(e); });
                    this.event(window)
                        .offon("orientationchange", (e) => { this.updateTouchZone(); })
                        .offon("resize", (e) => { this.updateTouchZone(); });
                    Controls.VideoPlayer.Events.ControlsVisibilityChanged({
                        selector: this.player,
                        callback: (c, e) => {
                            setTimeout(() => {
                                this.controlsIsVisible = e.data.isVisible;
                                this.updateTouchZone(e.data.size);
                            }, 300);
                        }
                    });
                    Controls.VideoPlayer.Events.VideoLoaded({
                        selector: this.player,
                        callback: (c, e) => {
                            this.updateTouchZone();
                        }
                    });
                }
                OnDispose() {
                }
                updateTouchZone(controlsSize) {
                    if (!controlsSize)
                        controlsSize = { Height: this.player.controls.height(), Width: this.player.controls.width() };
                    var videoHeight = this.player.$Control.height();
                    this.toleranceMargin = videoHeight * 0.15;
                    var thumbHeight = $(this.elements.progressThumb).height();
                    this.touchZone.videoPagePosition = point(this.player.$Control.offset());
                    var touchZoneHeight = this.toleranceMargin * 2;
                    this.touchZone.relativeZone = {
                        Height: touchZoneHeight,
                        Width: this.player.$Control.width(),
                        X: 0,
                        Y: videoHeight - touchZoneHeight + thumbHeight - (this.controlsIsVisible ? this.player.controls.height() : 0)
                    };
                    //console.log("touchZone", this.touchZone.relativeZone);
                    //console.log("page touchZone", this.touchZone.pageZone);
                    //console.log("Controls pane Offset: ", this.player.controls.offset());
                    if (this.touchZoneDebugDisplay == null) {
                        this.touchZoneDebugDisplay = $('<div></div>').addClass("touchZoneDebugDisplay");
                        $("body").append(this.touchZoneDebugDisplay);
                    }
                    this.touchZoneDebugDisplay.css({
                        top: this.touchZone.pageZone.Y + "px",
                        left: this.touchZone.pageZone.X + "px",
                        height: this.touchZone.pageZone.Height + "px",
                        width: this.touchZone.pageZone.Width + "px"
                    });
                }
                progressTouched(e) {
                    var progressPageOffset = this.elements.progressContainer.offset();
                    var offsetTouch = e.originalEvent.touches[0].pageX - progressPageOffset.left;
                    var seconds = this.player.Progress.positionToSeconds(offsetTouch);
                    this.player.Seek(seconds);
                }
                touchmove(e) {
                    if (this.touchIsInZone && hasTouch(e)) {
                        //e.preventDefault();
                        e.stopPropagation();
                        this.lastTouchEvent = e;
                        requestAnimationFrame(() => {
                            var touch = e.originalEvent.touches[0];
                            //var delta = touch.clientX - this.touchDownPosition.X;
                            //var newX = this.thumbDownPosition + delta;
                            //this.progressThumb.css("left", `${newX}px`);
                            //this.currentThumbX = newX;
                            this.currentThumbX = this.player.Progress.ThumbMove_Move(touch.pageX);
                            this.player.Progress.progressTooltips.update(this.currentThumbX, false);
                        });
                    }
                }
                touchcancel(e) {
                    this.stopTouch();
                }
                stopTouch(e) {
                    if (this.touchIsInZone) {
                        this.touchIsInZone = false;
                        this.player.Progress.ThumbMode_End();
                        this.player.Progress.progressTooltips.hide();
                        this.resumeVideoTouched();
                        if (e == null || !hasTouch(e))
                            e = this.lastTouchEvent;
                        if (e != null && hasTouch(e)) {
                            var touch = e.originalEvent.touches[0];
                            var movedX = Math.abs(touch.pageX - this.touchDownPosition.X);
                            var movedY = Math.abs(touch.pageY - this.touchDownPosition.Y);
                            if (movedX < 10 && movedY < this.toleranceMargin) {
                                //here it's a small move distance in the upper half of the touchable zone
                                return false;
                            }
                        }
                        return true;
                    }
                    return null;
                }
                touchend(e) {
                    if (this.touchIsInZone)
                        e.stopPropagation();
                    if (e == null || !hasTouch(e))
                        e = this.lastTouchEvent;
                    if (this.stopTouch(e) == false) {
                        if (hasTouch(e) && this.touchZone.isOverControl(e.originalEvent.touches[0], this.player.controls)) {
                            if (this.touchZone.isOverControl(e.originalEvent.touches[0], this.elements.progressContainer)) {
                                this.progressTouched(e);
                            }
                            else {
                                var button = this.touchZone.isOverControls(e.originalEvent.touches[0], this.player.buttons);
                                if (button != null) {
                                    button.click();
                                    return;
                                }
                            }
                        }
                        this.player.videoTouched.videoTouchend(e.originalEvent);
                    }
                }
                touchstart(e) {
                    if (hasTouch(e)) {
                        var touch = e.originalEvent.touches[0];
                        if (this.touchZone.isInZone(touch)) {
                            this.lastTouchEvent = e;
                            this.touchDownPosition = { X: touch.pageX, Y: touch.pageY };
                            //this.thumbDownPosition = this.progressThumb.position().left;
                            this.touchIsInZone = true;
                            this.player.Progress.progressTooltips.show();
                            this.resumeVideoTouched = this.player.videoTouched.Suspend();
                            this.player.Progress.ThumbMove_Begin(touch.pageX, 0);
                            //e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                }
            }
            VideoPlayerInternals.ProgressTouch = ProgressTouch;
            function hasTouch(e) {
                return e.originalEvent.touches && e.originalEvent.touches.length > 0;
            }
            function point(cord) {
                return { X: cord.left, Y: cord.top };
            }
            class TouchZone {
                get pageZone() {
                    return {
                        X: this.videoPagePosition.X + this.relativeZone.X,
                        Y: this.videoPagePosition.Y + this.relativeZone.Y,
                        Height: this.relativeZone.Height,
                        Width: this.relativeZone.Width
                    };
                }
                isInZone(touch) {
                    var pageZone = this.pageZone;
                    if (touch.pageX >= pageZone.X && touch.pageY >= pageZone.Y)
                        if (touch.pageX <= pageZone.X + pageZone.Width && touch.pageY <= pageZone.Y + pageZone.Height)
                            return true;
                    return false;
                }
                isOverControl(touch, element, radiusMargin = 0) {
                    var position = element.offset();
                    if (touch.pageX >= position.left && touch.pageY >= position.top)
                        if (touch.pageX <= position.left + element.width() && touch.pageY <= position.top + element.height())
                            return true;
                    return false;
                }
                isOverControls(touch, elements, radiusMargin = 0) {
                    var result = null;
                    elements.each((index, element) => {
                        if (!result) {
                            var e = $(element);
                            if (this.isOverControl(touch, e, radiusMargin))
                                result = e;
                        }
                    });
                    return result;
                }
            }
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.ProgressTouch.js.map
